export enum SelfcareEnum {
    EDPPT = "edp.pt",
    EDPONLINE = "edponline",
    OUTROS = "outros"
}
